export default {"src":"/_next/static/media/0xad6caeb32cd2c308980a548bd0bc5aa4306c6c18.fa0c5f23.svg","height":47,"width":47,"blurWidth":0,"blurHeight":0};